import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SORT_DESC } from 'ra-core/lib/reducer/admin/resource/list/queryReducer';
import NativeSelect from '@material-ui/core/NativeSelect';
import { withStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';

import Refresh from '../../../components/Refresh';
import CompanyList from '../../../components/UrCompanyList';
import {
  restClient,
  dateToHtmlInputDate,
  getDateString,
  formatPercentages,
  formatRubMoney,
  addCounters,
  aggregateSum,
  aggregatePercentages,
  CALLCENTER_PLAN, getDateByDayId
} from '../../../common';
import CustomerDatagrid from './Datagrid';
import EjectedList from '../../../components/ejected/List';

import Header from './Header';

import DatePickers from '../../../components/DatePickers';

import { updateCounters as updateCountersAction } from '../../../redux/actions';

const StyledNativeSelect = withStyles({
  select: {
    width: '173px'
  }
})(NativeSelect);

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companies: [],
      filter: {
        company: 'all',
        plan: 'all',
        fired: true,
        'date-from': getDateByDayId(-30).toISOString(),
        'date-to': getDateByDayId(0, true).toISOString()
      }
    };

    Promise.all([
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: 'all',
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        fired: this.state.filter.fired
      }),
      restClient('GET_CUSTOM', 'statistics-company', {
        company: 'all',
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        plan: this.state.filter.plan,
        fired: this.state.filter.fired,
        sumAll: true
      }),
    ]).then(values => {
      this.props.updateCounters(values[1]);
      this.setState({
        companies: values[0]
      });
    });

  }

  onCompanySelect(companyId) {
    this.setState({
      filter: {
        ...this.state.filter,
        company: companyId
      }
    });
    restClient('GET_CUSTOM', 'statistics-company', {
      company: companyId,
      'date-from': this.state.filter['date-from'],
      'date-to': this.state.filter['date-to'],
      plan: this.state.filter.plan,
      fired: this.state.filter.fired,
      sumAll: true
    }).then(res => {
      this.props.updateCounters(res);
    });
  }

  onPlanSelect(evt) {
    const plan = evt.target.value;

    this.setState({
      filter: {
        ...this.state.filter,
        plan,
        company: 'all'
      }
    });

    Promise.all([
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan,
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        fired: this.state.filter.fired
      }),
      restClient('GET_CUSTOM', 'statistics-company', {
        company: 'all',
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        plan: plan,
        fired: this.state.filter.fired,
        sumAll: true
      })
    ]).then(values => {
      this.props.updateCounters(values[1]);
      this.setState({
        companies: values[0]
      });
    });
  }

  onDateChangeFrom(evt) {
    const date = new Date(evt.target.value);
    date.setHours(0, 0, 0, 0);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-from': resultDate
      }
    });

    Promise.all([
      restClient('GET_CUSTOM', 'statistics-company', {
        company: this.state.filter.company,
        'date-from': resultDate,
        'date-to': this.state.filter['date-to'],
        plan: this.state.filter.plan,
        fired: this.state.filter.fired,
        sumAll: true
      }),
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: this.state.filter.plan,
        'date-from': resultDate,
        'date-to': this.state.filter['date-to'],
        fired: this.state.filter.fired
      })
    ]).then(values => {
      this.props.updateCounters(values[0]);
      this.setState({
        companies: values[1]
      });
    });
  }

  onDateChangeTo(evt) {
    const date = new Date(evt.target.value);
    date.setHours(23, 59, 59, 999);
    const resultDate = date.toISOString();

    this.setState({
      filter: {
        ...this.state.filter,
        'date-to': resultDate,
      }
    });

    Promise.all([
      restClient('GET_CUSTOM', 'statistics-company', {
        company: this.state.filter.company,
        'date-from': this.state.filter['date-from'],
        'date-to': resultDate,
        plan: this.state.filter.plan,
        fired: this.state.filter.fired,
        sumAll: true
      }),
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: this.state.filter.plan,
        'date-from': this.state.filter['date-from'],
        'date-to': resultDate,
        fired: this.state.filter.fired
      })
    ]).then(values => {
      this.props.updateCounters(values[0]);
      this.setState({
        companies: values[1]
      });
    });
  }

  firedCheckboxClick(evt, value) {
    this.setState({
      filter: {
        ...this.state.filter,
        fired: value,
      }
    });
    Promise.all([
      restClient('GET_CUSTOM', 'statistics-company', {
        company: this.state.filter.company,
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        plan: this.state.filter.plan,
        fired: value,
        sumAll: true
      }),
      restClient('GET_CUSTOM', 'getCompaniesList', {
        plan: this.state.filter.plan,
        'date-from': this.state.filter['date-from'],
        'date-to': this.state.filter['date-to'],
        fired: value
      })
    ]).then(values => {
      this.props.updateCounters(values[0]);
      this.setState({
        companies: values[1]
      });
    });
  }

  getCurrentCompany() {
    if (this.state.filter.company === 'all') {
      return {
        balance: aggregateSum(this.state.companies, 'balance'),
        count: aggregateSum(this.state.companies, 'count'),
        ctr: aggregatePercentages(this.state.companies),
        id: 'all',
        name: 'Все Юридические Компании',
        noanswer: aggregateSum(this.state.companies, 'noanswer'),
        payments: aggregateSum(this.state.companies, 'payments'),
        rejected: aggregateSum(this.state.companies, 'rejected'),
        sum: aggregateSum(this.state.companies, 'sum'),
        verified: aggregateSum(this.state.companies, 'verified'),
        visited: aggregateSum(this.state.companies, 'visited'),
        treaty: aggregateSum(this.state.companies, 'treaty'),
      };
    }
    const companyIndex = this.state.companies.findIndex(i => i.id === this.state.filter.company);
    return this.state.companies[companyIndex];
  }

  getCompanyName() {
    const id = this.state.filter.company;
    if (id === 'all') {
      return 'во Все Юридические компании';
    }
    return 'в Юридическую компанию';
    // return `в ${this.state.companies.find(company => company.id === this.state.filter.company).name}`;
  }

  getTitle(companies, filter) {
    if (companies.length && filter && filter.company && filter['date-to']) return `Записи на ${getDateString(new Date(filter['date-to']))}, ${this.getCompanyName()} `;
    if (companies.length && filter && filter.company) return `Записи ${this.getCompanyName()} `;
    if (filter && filter['date-to']) return `Записи на ${getDateString(new Date(filter['date-to']))}, `;
    return 'Записи, ';
  }

  render() {
    const passedProps = { ...this.props };
    delete (passedProps.updateCounters);
    const countersFunc = company => ({
      counters: [
        { count: company.count, style: { color: '#2C9BC3' } },
        { count: company.visited, style: { color: '#35CD59' } },
        { count: company.ctr, formatFunc: formatPercentages, style: { color: '#353535' } },
        { count: company.sum, formatFunc: formatRubMoney, style: { color: '#353535' } }
      ]
    });

    const currentCompany = this.getCurrentCompany();

    return (
      <div className="col-wrapper">
        <div className="col-menu">
          <StyledNativeSelect
            value={this.state.filter.plan}
            onChange={this.onPlanSelect.bind(this)}
            style={{
              marginLeft: '20px',
              marginTop: '9px'
            }}
          >
            <option key="all" value="all">Все типы</option>
            {this.props.plans.map(({ _id, callcenters }) => {
              const callcentersArray = callcenters.map((callcenter) => <option key={callcenter.id} value={callcenter.id}>- {callcenter.name}</option>);
              const planTree = [<option key={_id} value={_id}>{CALLCENTER_PLAN.find(callcenter => callcenter.id === _id).name}</option>];
              return planTree.concat(callcentersArray);
            })}
          </StyledNativeSelect>
          <CompanyList
            data={addCounters(countersFunc)(this.state.companies)}
            selectedId={this.state.filter.company}
            onSelect={this.onCompanySelect.bind(this)}
            aggregate={{
              title: 'Все Компании',
              counters: [
                { count: aggregateSum(this.state.companies, 'count'), style: { color: '#2C9BC3' } },
                { count: aggregateSum(this.state.companies, 'visited'), style: { color: '#35CD59' } },
                { count: aggregatePercentages(this.state.companies), formatFunc: formatPercentages, style: { color: '#353535' } },
                { count: aggregateSum(this.state.companies, 'sum'), formatFunc: formatRubMoney, style: { color: '#353535' } }]
            }}
          />
        </div>
        <div className="col-main">
          <Paper elevation={0} style={{ height: '44px', width: '1014px', margin: '6px 0px 7px 10px' }}>
            <span style={{
              fontSize: '13px',
              fontWeight: '400',
              color: '#3a3a3a',
              marginLeft: '11px',
              marginRight: '7px',
              display: 'inline-block',
              top: '-8px',
              position: 'relative'
            }}
            >
                С:
            </span>
            <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-from']))} onChange={this.onDateChangeFrom.bind(this)} style={{ top: '-7px' }} />
            <span style={{
              fontSize: '13px', fontWeight: '400', color: '#3a3a3a', marginLeft: '11px', marginRight: '7px', display: 'inline-block', top: '-8px', position: 'relative'
            }}
            >По:
            </span>
            <DatePickers defaultValue={dateToHtmlInputDate(new Date(this.state.filter['date-to']))} onChange={this.onDateChangeTo.bind(this)} style={{ top: '-7px' }} />
            <FormControlLabel
              style={{ position: 'relative', marginLeft: '445px', top: '-3px' }}
              control={(
                <Checkbox
                  checked={this.state.filter.fired}
                  onChange={this.firedCheckboxClick.bind(this)}
                    // value={true}
                  color="primary"
                />
              )}
              label="Показать уволенных"
            />
          </Paper>

          <EjectedList
            {...passedProps}
            title={this.getTitle(this.props.companies, this.state.filter)}
            sort={{ field: 'count', order: SORT_DESC }}
            perPage={50}
            actions={<Refresh />}
            filter={this.state.filter}
            bulkActions={false}
            style={{ width: '1024px' }}
            headercomponent={Header}
            companies={this.props.companies}
            currentCompany={currentCompany}
            pagination={null}
          >
            <CustomerDatagrid showCounters/>
          </EjectedList>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  companies: state.sc.companies,
  plans: state.sc.plans,
}), { updateCounters: updateCountersAction })(List);



// WEBPACK FOOTER //
// ./src/pages/admin/statistics_callcenter/List.js